<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_x">CONTENTS</a></p><a id="page_x">
</a><p class="tocb"><a id="page_x"></a><span href="#/html/5496_04_pre#pre" title="Link target outside of Sample">Preface</span></p>
<p class="toc"><a href="#/html/5496_06_int#int">INTRODUCTION: The Discovery of the American Indian</a></p>
<p class="toct"><a href="#/html/5496_07_ch1#ch1">CHAPTER I: The Early Origin Literature, Oviedo to Acosta</a></p>
<p class="toc1"><a href="#/html/5496_07_ch1#lev1"><em>Beginnings of the Origin Literature, 1535–1540</em></a></p>
<p class="toc1"><a href="#/html/5496_07_ch1#lev2"><em>Expansion of the Argument, 1540–1580</em></a></p>
<p class="toc1"><a href="#/html/5496_07_ch1#lev3"><em>The Ten Lost Tribes of Israel and the Ophirites</em></a></p>
<p class="toct"><span href="#/html/5496_08_ch2#ch2" title="Link target outside of Sample">CHAPTER II: Acosta and García, 1589–1607</span></p>
<p class="toc1"><span href="#/html/5496_08_ch2#lev4" title="Link target outside of Sample"><em>Joseph de Acosta and the Acostan Tradition</em></span></p>
<p class="toc1"><span href="#/html/5496_08_ch2#lev5" title="Link target outside of Sample"><em>Gregorio García and the Garcían Tradition</em></span></p>
<p class="toct"><span href="#/html/5496_09_ch3#ch3" title="Link target outside of Sample">CHAPTER III: Spanish Scholarship after García, 1607–1729</span></p>
<p class="toct"><span href="#/html/5496_10_ch4#ch4" title="Link target outside of Sample">CHAPTER IV: The Debate on the Origins of the Indians in Northern Europe</span></p>
<p class="toc1"><span href="#/html/5496_10_ch4#lev6" title="Link target outside of Sample"><em>Expansion of the Debate to Northern Europe, 1600–1640</em></span></p>
<p class="toc1"><span href="#/html/5496_10_ch4#lev7" title="Link target outside of Sample"><em>The Grotius–De Laet Controversy</em></span></p>
<p class="toc1"><span href="#/html/5496_10_ch4#lev8" title="Link target outside of Sample"><em>The Jews in America and The Hope of Israel, 1644–1660</em></span></p>
<p class="toc1"><span href="#/html/5496_10_ch4#lev9" title="Link target outside of Sample"><em>Toward New Criteria: La Peyrère and the Pre-Adamites</em></span></p>
<p class="toct"><span href="#/html/5496_11_gen#gen" title="Link target outside of Sample">General Conclusions</span></p>
<p class="toc"><span href="#/html/5496_12_bib#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/html/5496_13_ind#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5496_05_toc.vue?357616df